export function canAdministrate(role) {
  return role === 'admin';
};

export function canReadCustomers(role) {
  return ['admin', 'superStaff'].includes(role);
};
